import React from "react";
import Provider from "./TypeRegister/Provider/Provider"
import Logistic from "./TypeRegister/Logistic/Logistic"
import MultipleProfile from "./TypeRegister/MultipleProfile/MultipleProfile"
import WithoutProfile from "./TypeRegister/WithoutProfile/WithoutProfile"
import { useSelector } from 'react-redux';

function RegisterPage () {

	const permissions = useSelector(state => state.authorization.permissions);

	return (
		<div>
			{(!permissions[0] || permissions.length < 1) && <WithoutProfile/>}
			{permissions.length > 1 && <MultipleProfile permissions={permissions}/>}
			{(permissions.length === 1 && permissions[0] === "NPFornec_Renner_Fornecedor") && <Provider/>}
			{(permissions.length === 1 && permissions[0] === "NPFornec_Renner_Logistica") && <Logistic/>}
		</div>
	);
}

export default RegisterPage;